import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useValidator } from "react-joi";
import { updateShipmentRate } from "../../../../components/joi/settingsModalsSchema";
import { changeShipRateSetData } from "../../../../context/api/settings/change-shipment/changeShipRateSetData";
import { getShipmentApi } from "../../../../context/api/settings/get-values/getShipmentApi";
import { joiErrorMessage } from "../../extra/joiErrorMessage";
// FontAwesomeIcon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretUp,
  faCaretDown
} from "@fortawesome/free-solid-svg-icons";
// bootstrap
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { InputGroup } from "react-bootstrap";

const ChangeShipment = ({
  dataTransalte,
  onHide,
  lang,
  setMessageResponse,
}) => {
  const schema = updateShipmentRate(lang).schema;
  const { state, setData, setExplicitField, validate } = useValidator(schema);
  const [btnLoader, setBtnLoader] = useState(false);
  const [cookies] = useCookies();

  const [shipment, setShipment] = useState({
    data: {},
    loader: true,
  });

  useEffect(() => {
    const fetch = async () => {
      await getShipmentApi(lang, cookies, setShipment, setMessageResponse, setData);
    };
    fetch();
  }, []);

  const updateDollar = (e) => {
    setData((old) => ({
      ...old,
      dollar: e.target.value
    }));
  };

  const postData = async (e) => {
    e.preventDefault();
    const credintial = {
      dollar: state.$data.dollar,
    };
    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return changeShipRateSetData(
        lang,
        credintial,
        setMessageResponse,
        cookies,
        setBtnLoader,
        setShipment
      );
    }
  };
  return (
    <>
      <Modal.Header>
        <Modal.Title className="d-flex flex-column align-items-center w-100 fs-2">
          {dataTransalte.popups.settings.update_shipping_rate}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex gap-3 flex-column align-items-center justify-content-center"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {shipment.loader ? (
          <Spinner animation="border" variant="warning" className="my-5" />
        ) : (
          <>
            <Form.Group
              className="my-3 d-flex flex-column align-items-center w-50"
              controlId="formBasicEmail"
            >
              <Form.Label>
                {dataTransalte.popups.settings.ship_to_m3}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  defaultValue={shipment.data.dollar || 0}
                  onChange={updateDollar}
                  onBlur={() => setExplicitField("dollar", true)}
                  className="defaultControl"
                />
                <InputGroup.Text
                  className="arrow">
                  <FontAwesomeIcon
                    icon={
                      (shipment.data.status === 'higher' ? faCaretUp : faCaretDown)
                    }
                    size="xl"
                    className={
                      (shipment.data.status === 'higher' ? 'greenArrow' : 'redArrow')
                    }
                  />
                </InputGroup.Text>
              </InputGroup>

              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.dollar)}
              </Form.Text>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="w-100 d-flex flex-row align-items-center">
        <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
          <Button
            onClick={(e) => {
              validate();
              postData(e);
            }}
            disabled={btnLoader ? true : false}
          >
            {dataTransalte.pages.navbar.settings.update}
          </Button>
          <Button onClick={onHide}>
            {dataTransalte.pages.navbar.settings.close}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};
export default ChangeShipment;
